<template>
  <md-button class="md-button  w-100 pt-3 pb-3" :class="buttonClass" disabled>
    <span :class="iconClass" role="status" aria-hidden="true"></span>
    {{ $t(text) }}
  </md-button>
</template>
<script>
import componentMixin from "ireal-vue/mixins/component-mixin.js";

export default {
  name: "button-component",
  mixins: [componentMixin],
  computed: {
    text() {
      if (this.$store.getters.isFinished) {
        return "spinner_Completed";
      } else {
        if (this.$store.getters.player.isPlaying) {
          if (this.$store.getters.player.speed == 1) {
            return this.attributes.text?this.attributes.text:"spinner_progress";
          } else {
            return `${this.$t("spinner_speed")} ${
              this.$store.getters.player.speed
            }`;
          }
        } else {
          return "spinner_Paused";
        }
      }
    },
    buttonClass() {
      return this.$store.getters.player.speed == 1 ||
        this.$store.getters.isFinished
        ? "md-warning"
        : "md-primary";
    },
    iconClass() {
      var classe = "";
      if (!this.$store.getters.isFinished) {
        classe = this.$store.getters.player.isPlaying ? "border" : "grow";
      }
      return `spinner-${classe} spinner-${classe}-sm`;
    }
  }
};
</script>
<style>
button: {
  margin: 1%;
}
.md-button {
  opacity: 1 !important;
}
</style>
